export default __webpack_public_path__ + "static/reactnative-be2a5ddba2e175c4df8d1113c8c1f59f.png";